import { FC } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import MenuSingleItem from '../../MenuSingleItem'
import MenuFakeItem from '../../MenuFakeItem'
import { Text, IconWrapper } from '../../../_styles'
import Indicator from '../../Indicator'
import { ProBadge } from 'components/Common/Menu/Sidebar/Navigation/_styles'
import proBadgeUrl from 'components/Pages/Retail/_assets/pro.png'

interface SubItemProps {
  title: string
  link: string
  badge?: (state: any) => boolean | number
  onSelect?: () => void
  disabled?: boolean
  isPro?: boolean
  active?: boolean
}

const SubItem: FC<SubItemProps> = props => {
  const { title, link, onSelect, disabled, active, badge, isPro } = props

  const { t } = useTranslation()

  const counter = badge ? useSelector(badge) : false

  const content = (
    <>
      <IconWrapper />
      <Text>
        {t(title)} <Indicator value={counter} />
        {isPro && <ProBadge src={proBadgeUrl} />}
      </Text>
    </>
  )

  return disabled ? (
    <MenuFakeItem sub>{content}</MenuFakeItem>
  ) : (
    <MenuSingleItem
      isActive={active ?? false}
      link={link}
      onSelect={onSelect}
      sub
    >
      {content}
    </MenuSingleItem>
  )
}

export default SubItem
